import React from "react";
import { Col, Row } from 'antd';


const CleanEnergy = () => {
  return (
    <div className="clean-energy">
      <div className="k2s-green-container defaultPadding">
        
          <Row data-aos="fade-left" data-aos-duration="500">
              <Col className="gutter-row coltype"  xs={24} sm={12} md={12} >
              <div className="header-title white">
                <h2>Pioneering a New Era in Clean Energy</h2>
                <p className="blue">
                  We enable businesses and homeowners to smoothly migrate to wind,
                  solar, and hydrogen solutions with real-time analytics and
                  unrivalled transparency as a technology-driven partner.
                </p>
                <p className="blue">The mission is simple:</p>
              </div>
              </Col>
          </Row>
            
              
         
          <Row gutter={32} className="pdt50">
            <Col className="gutter-row coltype"  xs={24} sm={12} md={8} >
            <div className="columnStyle s1" data-aos="fade-up" data-aos-duration="500">
                  <div className="counter mt70">01</div>
                  <h5>Accessible Energy</h5>
                  <p> Deliver sustainable energy solutions that reduce costs and boost efficiency </p>
              </div>
            </Col>
            <Col className="gutter-row coltype"  xs={24} sm={12} md={8} >
            <div className="columnStyle s1" data-aos="fade-up" data-aos-duration="900">
                    <div className="counter mt70">02</div>
                    <h5>Data-Driven Optimization</h5>
                    <p> Harness real-time analytics and AI to streamline energy usage and minimize environmental impact. </p>
                </div>
            </Col>
            <Col className="gutter-row coltype"  xs={24} sm={12} md={8} >
                <div className="columnStyle s1"  data-aos="fade-up" data-aos-duration="1200">
                  <div className="counter mt70">03</div>
                  <h5>ESG Empowerment</h5>
                  <p> Enable businesses to meet global ESG standards, ensuring compliance and sustainable growth. </p>
                </div>
            </Col>
        
          </Row>
  
      
      </div>
    </div>
  );
};

export default CleanEnergy;